// extracted by mini-css-extract-plugin
export default {"Subtitle":"subtitle_Subtitle__PV9aD"};